"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeetingCategoryEnum = void 0;
/**
 * Категории индивидуальных занятий
 *
 * @deprecated
 * @see UserServiceCategory
 */
var MeetingCategoryEnum;
(function (MeetingCategoryEnum) {
  /** Индивидуальные занятия */
  MeetingCategoryEnum[MeetingCategoryEnum["personal"] = 1] = "personal";
  /** Разговорная практика */
  MeetingCategoryEnum[MeetingCategoryEnum["speaking"] = 2] = "speaking";
  /** Подготовка к экзаменам и тестам */
  MeetingCategoryEnum[MeetingCategoryEnum["exam_training"] = 3] = "exam_training";
  /** Для детей */
  MeetingCategoryEnum[MeetingCategoryEnum["for_children"] = 4] = "for_children";
})(MeetingCategoryEnum = exports.MeetingCategoryEnum || (exports.MeetingCategoryEnum = {}));
